interface EstruturaVivaProps {
  data: unknown;
}

export function EstruturaViva({ data }: EstruturaVivaProps) {
  if (data === null || data === undefined) {
    return <span style={{ color: 'var(--text-4)' }}>null</span>;
  }

  if (Array.isArray(data)) {
    return (
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          border: '1px solid var(--border-1)',
          fontSize: '14px',
        }}
      >
        <tbody>
          {data.map((item, i) => (
            <tr key={i}>
              <td
                style={{
                  border: '1px solid var(--border-1)',
                  padding: '4px 8px',
                  verticalAlign: 'top',
                  backgroundColor: 'var(--bg-2)',
                  width: '1%',
                }}
              >
                {i}
              </td>
              <td
                style={{
                  border: '1px solid var(--border-1)',
                  padding: '4px 8px',
                  color: 'var(--text-1)',
                }}
              >
                <EstruturaViva data={item} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  if (typeof data === 'object') {
    return (
      <div
        style={{
          marginLeft: '12px',
          borderLeft: '2px solid var(--border-2)',
          paddingLeft: '8px',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        {Object.entries(data).map(([key, value]) => (
          <div key={key}>
            <strong style={{ color: 'var(--text-1)' }}>{key}:</strong>{' '}
            <div style={{ marginTop: '2px' }}>
              <EstruturaViva data={value} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <span style={{ color: 'var(--nexus-brand)', wordBreak: 'break-word' }}>{String(data)}</span>
  );
}
